import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export function hitLangSwitch(langCode: string) {
    hitGoogleTagManager({
        event: "language_swap",
        language: langCode
    });
}
